function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Entity } from "../../util/Entity";
/**
 * Base class for patterns.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/colors-gradients-and-patterns/patterns/} for more info
 */
export var Pattern = /*#__PURE__*/function (_Entity) {
  _inherits(Pattern, _Entity);
  var _super = _createSuper(Pattern);
  function Pattern() {
    var _this;
    _classCallCheck(this, Pattern);
    _this = _super.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), "_display", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._root._renderer.makeGraphics()
    });
    Object.defineProperty(_assertThisInitialized(_this), "_backgroundDisplay", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._root._renderer.makeGraphics()
    });
    Object.defineProperty(_assertThisInitialized(_this), "_clear", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_pattern", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    return _this;
  }
  _createClass(Pattern, [{
    key: "_afterNew",
    value: function _afterNew() {
      // Applying themes because pattern will not have parent
      _get(_getPrototypeOf(Pattern.prototype), "_afterNewApplyThemes", this).call(this);
    }
  }, {
    key: "pattern",
    get: function get() {
      return this._pattern;
    }
  }, {
    key: "_draw",
    value: function _draw() {}
  }, {
    key: "_beforeChanged",
    value: function _beforeChanged() {
      _get(_getPrototypeOf(Pattern.prototype), "_beforeChanged", this).call(this);
      if (this.isDirty("repetition") || this.isDirty("width") || this.isDirty("height") || this.isDirty("rotation") || this.isDirty("color") || this.isDirty("strokeWidth") || this.isDirty("strokeDasharray") || this.isDirty("strokeDashoffset") || this.isDirty("colorOpacity") || this.isDirty("fill") || this.isDirty("fillOpacity")) {
        this._clear = true;
      }
    }
  }, {
    key: "_changed",
    value: function _changed() {
      _get(_getPrototypeOf(Pattern.prototype), "_changed", this).call(this);
      if (this._clear) {
        var repetition = this.get("repetition", "");
        var width = this.get("width", 100);
        var height = this.get("height", 100);
        var fill = this.get("fill");
        var fillOpacity = this.get("fillOpacity", 1);
        this._display.clear();
        this._backgroundDisplay.clear();
        if (fill && fillOpacity > 0) {
          this._backgroundDisplay.beginFill(fill, fillOpacity);
          this._backgroundDisplay.drawRect(0, 0, width, height);
          this._backgroundDisplay.endFill();
        }
        this._display.angle = this.get("rotation", 0);
        //this._display.pivot = { x: width / 2, y: height / 2 };
        this._draw();
        this._pattern = this._root._renderer.createPattern(this._display, this._backgroundDisplay, repetition, width, height);
      }
    }
  }]);
  return Pattern;
}(Entity);
Object.defineProperty(Pattern, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Pattern"
});
Object.defineProperty(Pattern, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Entity.classNames.concat([Pattern.className])
});